export const EMPLOYEE_TRAINING = [
  "dealerName",
  "employeeLadaAcademiaId",
  "fio",
  "positionName",
  "basicLevelStatus",
  "standardLevelStatus",
  "certificationLevelStatus",
  // "level_start",
  // "level_base",
  // "level_standard",
  // "level_cert",
  // "level_expert",
];
